
/*
 * Carousel par défaut
 * Ajout de la classe "disabled" sur les boutons "précédent" et "suivant" lorsque on est au premier ou au dernier élément
 */
if (document.querySelector('.carousel')) {
  const carousels = document.querySelectorAll(".carousel");

  carousels.forEach(carousel => {
    const prevBtn = carousel.querySelector(".carousel-control-prev");
    const nextBtn = carousel.querySelector(".carousel-control-next");
    const items = carousel.querySelectorAll(".carousel-item");
    const controls = carousel.querySelector(".carousel-controls-block");
    const totalItems = items.length;

    function updateButtons() {
      const activeIndex = [...items].findIndex(item => item.classList.contains("active"));

      const isFirst = activeIndex === 0;
      const isLast = activeIndex === totalItems - 1;

      // Ajouter ou retirer la classe "disabled"
      prevBtn.classList.toggle("disabled", isFirst);
      nextBtn.classList.toggle("disabled", isLast);

      // Ajouter ou retirer l'attribut "disabled"
      prevBtn.toggleAttribute("disabled", isFirst);
      nextBtn.toggleAttribute("disabled", isLast);
    }

    if (totalItems > 1) {
      // Initialisation
      updateButtons();

      // Mettre à jour les boutons après chaque transition
      carousel.addEventListener("slid.bs.carousel", updateButtons);
    } else {
      controls.style.display = "none"; // Hide controls if not enough items
    }
  });
}
